import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API


export const getSpecPhk = createAsyncThunk(
    "phkTransaksi/getSpecPhk",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecPhk',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getPhkTransaksi = createAsyncThunk(
    "phkTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getPhk',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertPhkTransaksi = createAsyncThunk(
    "phkTransaksi/insert",
    async ({
               Nik,
               TanggalPengajuan,
               Alasan,
               AsetPemilikanPerusahaan,
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("TanggalPengajuan", TanggalPengajuan);
        formData.append("Alasan", Alasan);
        formData.append("AsetPemilikanPerusahaan", AsetPemilikanPerusahaan);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertPhk',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updatePhkTransaksi = createAsyncThunk(
    "phkTransaksi/update",
    async ({
               TPhkID,
               Nik,
               TanggalPengajuan,
               Alasan,
               AsetPemilikanPerusahaan,
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("TPhkID", TPhkID);
        formData.append("Nik", Nik);
        formData.append("TanggalPengajuan", TanggalPengajuan);
        formData.append("Alasan", Alasan);
        formData.append("AsetPemilikanPerusahaan", AsetPemilikanPerusahaan);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updatePhk',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getPhkReport = createAsyncThunk(
    "getPhkReport/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/phk/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getPhkReportDetail = createAsyncThunk(
    "getPhkReportDetail/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/phk/lap/detail',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetPhkSlice = createAsyncThunk(
    "resetPhkSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
export const resetPhkDetailSlice = createAsyncThunk(
    "resetPhkDetailSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecPhkData: [],
    isSpecPhkFetching: false,
    isSpecPhkSuccess: false,
    isSpecPhkError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false,
    isGetReportDetail: false,
};


//SLICES
export const phkTransaksiSlice = createSlice({
    name: "pengobatanTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getPhkReport.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.isGetReport = true;
            state.message = payload.message;
            return state;
        },
        [getPhkReport.rejected]: (state, {payload}) => {
            state.isGetReport = false;
        },
        [getPhkReport.pending]: (state) => {
            state.isGetReport = false;
        },

        [getPhkReportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.reportDetail = payload.data;
                state.message = payload.message;
            }
            state.isGetReportDetail = true;
            return state;
        },
        [getPhkReportDetail.rejected]: (state, {payload}) => {
            state.isGetReportDetail = false;
        },
        [getPhkReportDetail.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [resetPhkDetailSlice.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [getSpecPhk.fulfilled]: (state, {payload}) => {
            state.SpecPhkData = payload.data[0];
            state.isSpecPhkSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecPhk.rejected]: (state, {payload}) => {
            state.isSpecPhkFetching = false;
        },
        [getSpecPhk.pending]: (state) => {
            state.isSpecPhkFetching = false;
        },
        [getSpecPhk.fulfilled]: (state, {payload}) => {
            state.SpecPhkData = payload.data[0];
            state.isSpecPhkSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecPhk.rejected]: (state, {payload}) => {
            state.isSpecPhkFetching = false;
        },
        [getSpecPhk.pending]: (state) => {
            state.isSpecPhkFetching = false;
        },

        [getPhkTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getPhkTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getPhkTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertPhkTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertPhkTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertPhkTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updatePhkTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updatePhkTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updatePhkTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const phkTransaksiSelector = (state) => state.phkTransaksi;
  